import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shorten',
})
export class ShortenPipe implements PipeTransform {
  transform(value: string, limit: number = 50, suffix: string = '...'): string {
    if (!value) {
      return value;
    }

    if (value.length <= limit) {
      return value;
    }

    return value.substring(0, limit) + suffix;
  }
}
